export const setCookie = async (key, value, days) => {
    if (window.cookieStore && window.cookieStore.set) {
        window.cookieStore
            .set({
                name: key,
                value: value,
                expires: Date.now() + days * 24 * 60 * 60 * 1000,
                sameSite: 'lax',
                domain: 'shopohs.es',
            })
            .catch(() => {
                setCookieFallback(key, value, days);
            });
    } else {
        setCookieFallback(key, value, days);
    }
};

const setCookieFallback = (key, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = '; expires=' + date.toUTCString();
    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}${expires}; path=/; sameSite=lax`;
};

export const getCookie = async (key) => {
    if (window.cookieStore) {
        try {
            const cookie = await window.cookieStore.get(key);
            return cookie ? cookie.value : null;
        } catch (error) {
            return getCookieFallback(key);
        }
    } else {
        return getCookieFallback(key);
    }
};

const getCookieFallback = (key) => {
    const name = encodeURIComponent(key) + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie && cookie.indexOf(name) === 0) {
            return cookie.substring(name.length);
        }
    }
    return null;
};

export const deleteCookie = async (key) => {
    if (window.cookieStore) {
        try {
            const cookie = await window.cookieStore.get(key);
            if (cookie) {
                await window.cookieStore.delete(cookie);
            }
        } catch (error) {
            deleteCookieFallback(key);
        }
    } else {
        deleteCookieFallback(key);
    }
};

const deleteCookieFallback = (key) => {
    const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
    document.cookie = `${key}=; ${expires}; path=/;`;
    const domain = window.location.hostname;
    document.cookie = `${key}=; ${expires}; path=/; domain=${domain};`;
    const dotDomain = `.${domain.split('.').slice(-2).join('.')}`;
    document.cookie = `${key}=; ${expires}; path=/; domain=${dotDomain};`;
};
